import { isInertiaPath } from '../utils/helpers';

/**
 * The first global guard: a route that belongs to a switched-on Inertia section (meta.inertia)
 * is rendered by the server, so leave the SPA with a full page load instead of showing the
 * legacy page. Inertia never router.visits a SPA URL, so this is the only crossing to watch.
 *
 * Navigating to the URL the page already shows is left alone, so this guard cannot reload in a loop.
 */
export const handOffToInertia = (to) => {
	if (!to.meta.inertia || to.path === window.location.pathname || !isInertiaPath(to.path)) {
		return;
	}

	window.location.assign(to.fullPath);

	return false;
};

export const getLoginRedirect = (query) => {
	try {
		const stored = localStorage.getItem('partnerBranding');
		const slug = stored ? JSON.parse(stored)?.slug : null;
		return { path: slug ? `/login/${slug}` : '/login', query };
	} catch {
		return { path: '/login', query };
	}
};

/**
 * Resolve where an unauthenticated user should be sent. When the Inertia login section
 * is switched on, hard-navigate to the server-rendered login (so GET /login or
 * /login/{slug} serves the Inertia page with partner branding) and return false to
 * cancel the in-SPA navigation. Otherwise fall back to the legacy client-side route.
 */
export const redirectToLogin = (query) => {
	const target = getLoginRedirect(query);

	if (isInertiaPath(target.path)) {
		const search = new URLSearchParams(query ?? {}).toString();
		window.location.assign(search ? `${target.path}?${search}` : target.path);
		return false;
	}

	return target;
};

/**
 * Imperative variant of redirectToLogin for component callers that navigate via
 * router.push (the guard returns the value directly instead).
 */
export const navigateToLogin = (router, query) => {
	const target = redirectToLogin(query);

	if (target !== false) {
		router.push(target);
	}
};
